'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'joystick';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f8c5';
var svgPathData = ['M112 320H80a16 16 0 0 0-16 16v16h64v-16a16 16 0 0 0-16-16zm112-96c-11.2 0-21.8-2.14-32-5.2V352h64V218.8c-10.2 3.06-20.8 5.2-32 5.2z', 'M416 352H32a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zM224 224a112 112 0 1 0-112-112 112 112 0 0 0 112 112zM200 48a24 24 0 1 1-24 24 24 24 0 0 1 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faJoystick = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;